class NetworkError extends Error {}

module.exports = NetworkError;
